import { render } from "./Asn.vue?vue&type=template&id=54245540"
import script from "./Asn.vue?vue&type=script&lang=js"
export * from "./Asn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__